var indentation_default = {
  "indentZero": "SSmro",
  "indentOne": "DEAFW",
  "indentTwo": "iIIH5",
  "indentThree": "jHP3J",
  "indentFour": "ZQYVG",
  "indentFive": "i7VoV",
  "indentSix": "X5OP6"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
